import type { SVGProps } from "react";
export default function ReadOnlyMode({ ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="6" cy="14" r="4" stroke="currentColor" strokeWidth="2" fill="none"></circle>
      <circle cx="18" cy="14" r="4" stroke="currentColor" strokeWidth="2" fill="none"></circle>
      <path
        d="M10 14C10.5 12 13.5 12 14 14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      ></path>
      <path d="M2 14L2 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"></path>
      <path d="M22 14L22 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"></path>
    </svg>
  );
}
